import { domAnimation, LazyMotion } from '@eversports/klimt-utilities/framer-motion'

import PublicProfilePrivacyTermsDisclaimer from './components/PublicProfilePrivacyTermsDisclaimer'
import ErrorBoundary from './ErrorBoundary'
import Pages from './pages'
import './global.css'

const App = () => {
  return (
    <ErrorBoundary>
      <LazyMotion features={domAnimation}>
        <Pages />
        <PublicProfilePrivacyTermsDisclaimer />
      </LazyMotion>
    </ErrorBoundary>
  )
}

export default App
